// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__lk_R8","selected":"Chip_selected__fbK7T"};